var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpirydate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.23948 2.08677V1.30998C9.23948 1.10582 9.07018 0.936523 8.86602 0.936523C8.66186 0.936523 8.49256 1.10582 8.49256 1.30998V2.05689H5.25594V1.30998C5.25594 1.10582 5.08664 0.936523 4.88248 0.936523C4.67832 0.936523 4.50902 1.10582 4.50902 1.30998V2.08677C3.16458 2.21125 2.51228 3.01294 2.41269 4.20302C2.40273 4.34743 2.52224 4.46693 2.66166 4.46693H11.0868C11.2312 4.46693 11.3507 4.34245 11.3358 4.20302C11.2362 3.01294 10.5839 2.21125 9.23948 2.08677Z",
    fill: "#A9A6A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.8576 5.21387C11.1315 5.21387 11.3555 5.43794 11.3555 5.71181V8.77914C11.3555 10.273 10.6086 11.2688 8.86583 11.2688H4.88229C3.13949 11.2688 2.39258 10.273 2.39258 8.77914V5.71181C2.39258 5.43794 2.61665 5.21387 2.89052 5.21387H10.8576Z",
    fill: "#A9A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.28749 7.7789L8.03851 8.03285H8.03353L6.52476 9.54162C6.46003 9.60635 6.32559 9.67607 6.23098 9.68603L5.55875 9.78561C5.31476 9.82046 5.14547 9.64619 5.18033 9.40718L5.27494 8.72997C5.28988 8.63536 5.3546 8.5059 5.41933 8.43619L6.93308 6.92742L7.18205 6.67346C7.34637 6.50914 7.53062 6.38965 7.72979 6.38965C7.89909 6.38965 8.08333 6.46931 8.28749 6.67346C8.73563 7.12161 8.59123 7.47515 8.28749 7.7789Z",
    fill: "black",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpirydate);
export default __webpack_public_path__ + "static/media/Expirydate.f0cc345323f6589a77dd6f570a11b492.svg";
export { ForwardRef as ReactComponent };